import React, {FC} from "react";
import {useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../redux/redux.hook";
import {confirmOrderThunk} from "../redux/suggestedAvailabilities.thunk";
import {Container, LinearProgress, Typography, useMediaQuery} from "@material-ui/core";
import vielenDank1 from "./VielenDank1.png";
import sieHabenMail from "./sieHabenMail.png";
import {Theme} from "@material-ui/core/styles";

export const OrderConfirmation: FC = () => {

    const dispatch = useAppDispatch();
    const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));
    const loading = useAppSelector((state) => state.suggestedAvailabilities.loading);
    const {orderId} = useParams<{ orderId: string }>();

    React.useEffect(() => {
        dispatch(confirmOrderThunk({orderId}))
    }, [dispatch, orderId])

    return (
        <Container>
            {loading ? (
                <React.Fragment>
                    <Typography variant="h5" style={{marginBottom: 16}}>Bestätigung in Arbeit</Typography>
                    <LinearProgress/>
                </React.Fragment>)
                : (
                   <React.Fragment>
                       <div style={{position: "relative", display: "flex"}}>
                           <img alt="vielen dank" src={vielenDank1} width={"100%"}/>
                           <Typography
                               variant="h4"
                               color="secondary"
                               style={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)"}}
                           >
                               Vielen Dank
                           </Typography>
                       </div>
                       <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
                           <Typography variant="h5" color="secondary"
                                       style={{textAlign: "center", marginTop: 64, marginBottom: 24}}>
                               Ihre Buchung war erfolgreich
                           </Typography>
                           <img style={{marginLeft: "auto", marginRight: "auto"}} alt="vielen dank" src={sieHabenMail}
                                width={200}/>
                           <Typography variant={isDesktop ? "h3" : "h5"} color="secondary" style={{textAlign: "center", marginBottom: 120}}>
                               Sie erhalten von uns eine Buchungsbestätigung per Email.
                           </Typography>
                       </div>
                   </React.Fragment>
                )
            }
        </Container>
    )
};
